import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { RecaptchaLoaderService } from '../services/recaptcha-loader.service';
import { RecaptchaEnterpriseService } from '../../utils/recaptcha-enterprise.service';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUs implements OnInit {

  formContact: FormGroup;
  private subscription: Subscription;
  public sending: boolean;
  public completed: boolean;
  public error: boolean;
  public serverErrors: string[] = [];
  private isServer: boolean;
  private readonly recaptchaAction = 'contact_form';
  private navigationSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(APP_SETTINGS) private settings: Object,
    private http: HttpClient,
    private recaptchaLoader: RecaptchaLoaderService,
    private recaptchaService: RecaptchaEnterpriseService,
    private router: Router
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    if (!this.isServer){
      window.scrollTo(0, 0);
      this.recaptchaLoader.load();
      this.navigationSubscription = this.router.events
        .filter(e => e instanceof NavigationStart)
        .subscribe(() => this.recaptchaLoader.unload());
    }

    this.formContact = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email_address: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.recaptchaLoader.unload();
  }

  onSubmit() {
    if (this.sending) {
      return;
    }

    if (this.formContact.invalid) {
      this.markFormGroupTouched(this.formContact);
      return;
    }

    this.sending = true;
    this.error = false;
    this.serverErrors = [];
    const formValue = this.formContact.value;
    const url = this.settings['DATA_API_ENDPOINT'] + '/contact-us';
    let formData: FormData = new FormData();
    for (let key of Object.keys(formValue)) {
      formData.append(key, formValue[key]);
    }
    formData.append('recaptcha_action', this.recaptchaAction);

    const submitRequest = () => {
      this.subscription = this.http
        .post(url, formData)
        .subscribe((data) => {
          this.serverErrors = Array.isArray(data['errors']) ? data['errors'] : [];
          const isSuccess = data && (data['status'] === 'sent' || data['success'] === true);
          if (!isSuccess) {
            this.error = true;
          }
          else {
            this.completed = true;
            this.error = false;
          }
          this.sending = false;
        },
        (err) => {
          if (err && err.error && Array.isArray(err.error.errors)) {
            this.serverErrors = err.error.errors;
          }
          this.error = true;
          this.sending = false;
        });
    };

    this.recaptchaLoader.load()
      .then(() => this.recaptchaService.execute(this.recaptchaAction))
      .then((token: string) => {
        formData.append('g-recaptcha-response', token || '');
        submitRequest();
      })
      .catch(() => {
        this.serverErrors = ['Unable to validate reCAPTCHA. Please try again.'];
        this.error = true;
        this.sending = false;
      });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control: any = formGroup.get(field);
      if (control && control.markAsTouched) {
        control.markAsTouched({ onlySelf: true });
      }
      if (control && control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/contact-us/contact-us.component.ts